import Vue from 'vue'
import Router from 'vue-router'
import Page from '@/components/pages/Page'
import Items from '@/components/items/Items'
import Users from '@/components/users/Users'
import Signin from '@/components/auth/Signin'
import Signup from '@/components/auth/Signup'
import Chart from '@/components/modules/Chart'
import Account from '@/components/auth/Account'
import Circles from '@/components/graph/Circles'
import ItemEdit from '@/components/items/ItemEdit'
import UserEdit from '@/components/users/UserEdit'
import Products from '@/components/products/Products'
import Suppliers from '@/components/suppliers/Suppliers'
import UserActivate from '@/components/users/UserActivate'
import ResetPassword from '@/components/auth/ResetPassword'
import ProductEdit from '@/components/products/ProductEdit'
import SupplierEdit from '@/components/suppliers/SupplierEdit'
import KnowledgeItems from '@/components/knowledge/KnowledgeItems'
import SupplierActivate from '@/components/suppliers/SupplierActivate'
import KnowledgeItemEdit from '@/components/knowledge/KnowledgeItemEdit'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: Chart
    },
    {
      path: '/kennis',
      name: 'knowledges',
      component: KnowledgeItems
    },
    {
      path: '/kennis/:id',
      name: 'knowledge-edit',
      component: KnowledgeItemEdit,
      props: { default: true }
    },
    {
      path: '/producten',
      name: 'products',
      component: Products
    },
    {
      path: '/producten/:id',
      name: 'product-edit',
      component: ProductEdit,
      props: { default: true }
    },
    {
      path: '/onderwerpen',
      name: 'items',
      component: Items,
    },
    {
      path: '/onderwerpen/bewerken/:id?',
      name: 'item-edit',
      component: ItemEdit,
    },
    {
      path: '/leveranciers',
      name: 'suppliers',
      component: Suppliers
    },
    {
      path: '/leveranciers/activeren/:token',
      name: 'supplier-activate',
      component: SupplierActivate,
      props: { default: true }
    },
    {
      path: '/leveranciers/bewerken/:id?',
      name: 'supplier-edit',
      component: SupplierEdit,
      props: { default: true }
    },
    {
      path: '/gebruikers',
      name: 'users',
      component: Users
    },
    {
      path: '/gebruikers/:id',
      name: 'user-edit',
      component: UserEdit,
      props: { default: true }
    },
    {
      path: '/aanmelden',
      name: 'signin',
      component: Signin
    },
    {
      path: '/account-maken',
      name: 'signup',
      component: Signup
    },
    {
      path: '/account',
      name: 'account',
      component: Account
    },
    {
      path: '/account/activeren/:token',
      name: 'account-activate',
      component: UserActivate
    },
    {
      path: '/account/wachtwoord-vergeten/:token?',
      name: 'recover-account',
      component: ResetPassword,
      props: { default: true }
    },
    {
      path: '/info',
      name: 'info',
      component: Page,
      props: {id: 1}
    },
    {
      path: '/contact',
      name: 'contact',
      component: Page,
      props: {id: 2}
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js